export default function Footer() {
  return (
    <footer
      className="relative z-10 border-t border-[var(--c-border)] bg-[var(--c-bg)] mt-16 sm:mt-24 safe-pb"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10 lg:px-16 py-10 sm:py-12 grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 items-start">
        <div>
          <p className="overline mb-2 sm:mb-3">Hello Dad</p>
          <h3 className="font-serif-display text-lg sm:text-xl text-[var(--c-text)]">
            Terence Peter Field
          </h3>
          <p className="text-xs sm:text-sm text-[var(--c-text-muted)] mt-1 font-mono-plex">
            01 · 07 · 1946
          </p>
        </div>
        <div className="sm:text-center">
          <p className="overline mb-2 sm:mb-3">A Life in Three Chapters</p>
          <p className="font-serif-display text-base sm:text-lg text-[var(--c-accent)] leading-snug">
            Navy · Career · World
          </p>
          <p className="text-xs sm:text-sm text-[var(--c-text-muted)] mt-1 sm:mt-2">
            Royal Navy 1962–1978 · Information Manager 1978 onward
          </p>
        </div>
        <div className="sm:text-right">
          <p className="overline mb-2 sm:mb-3">Your Words</p>
          <p className="text-xs sm:text-sm text-[var(--c-text-muted)] italic font-serif-display leading-relaxed">
            “Released into the real world — March 1978.”
          </p>
        </div>
      </div>
      <div className="border-t border-[var(--c-border)]">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10 lg:px-16 py-4 sm:py-5 flex flex-col sm:flex-row justify-between gap-1 text-[10px] sm:text-xs text-[var(--c-text-muted)] font-mono-plex">
          <span>Made for Dad · With love from your family.</span>
          <span>A private archive.</span>
        </div>
      </div>
    </footer>
  );
}
